export default __webpack_public_path__ + "static/media/com-converse.84123f8d.mp4";